var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.5818V14.498H2.91626L11.5173 5.89702L8.60103 2.98076L0 11.5818ZM13.7725 3.64178C14.0758 3.33849 14.0758 2.84855 13.7725 2.54526L11.9528 0.725515C11.6495 0.422224 11.1596 0.422224 10.8563 0.725515L9.43314 2.14865L12.3494 5.06491L13.7725 3.64178Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTags);
export default __webpack_public_path__ + "static/media/EditTags.5022934b0ef912dcf609b42cfae732f7.svg";
export { ForwardRef as ReactComponent };